import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-4">
              连接亚洲智慧，助力全球成长
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              亚洲人成长之路是一个专注于亚洲人群全面发展的知识平台。我们汇聚来自各行各业的亚洲精英，分享关于职业发展、个人成长、文化认同和自我提升的深刻洞察与实践经验。
            </p>
            <p className="text-foreground-600 leading-relaxed mb-6">
              我们的使命是帮助每一位亚洲人在全球化时代找到属于自己的成长路径，突破文化与职业的双重壁垒，实现个人价值的最大化。
            </p>
            <div className="flex flex-wrap gap-6 mb-6">
              <div>
                <span className="block font-heading text-2xl font-bold text-primary-600">200+</span>
                <span className="text-sm text-foreground-500">深度文章</span>
              </div>
              <div>
                <span className="block font-heading text-2xl font-bold text-primary-600">50+</span>
                <span className="text-sm text-foreground-500">资深作者</span>
              </div>
              <div>
                <span className="block font-heading text-2xl font-bold text-primary-600">10万+</span>
                <span className="text-sm text-foreground-500">月度读者</span>
              </div>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <div className="w-full h-80 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20collaborative%20workspace%20with%20diverse%20Asian%20professionals%20engaged%20in%20thoughtful%20discussion%2C%20modern%20minimalist%20interior%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20inspirational%20atmosphere%2C%20knowledge%20sharing%20theme&width=800&height=600&seq=about-preview-img&orientation=landscape"
                alt="关于亚洲人成长之路"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}